<div fxLayout="row wrap">
    <div fxFlex="100" fxFlex.gt-sm="50" class="p-2">
        <h2 class="text-muted text-center">Account details</h2>
        <form [formGroup]="infoForm" (ngSubmit)="onInfoFormSubmit(infoForm.value)">
            <mat-form-field class="w-100 mt-2">
                <input matInput placeholder="First Name" formControlName="first_name">
                <mat-error *ngIf="infoForm.controls.first_name.errors?.required">First Name is required</mat-error>
                <mat-error *ngIf="infoForm.controls.first_name.hasError('maxlength')">First Name characters should be within 35</mat-error>
                <mat-error *ngIf="infoForm.controls.first_name.hasError('validation')">
                    {{infoForm.controls.first_name.errors.message}}
                </mat-error>
            </mat-form-field>
            <mat-form-field class="w-100 mt-1">
                <input matInput placeholder="Last Name" formControlName="last_name">
                <mat-error *ngIf="infoForm.controls.last_name.errors?.required">Last Name is required</mat-error>
                <mat-error *ngIf="infoForm.controls.last_name.hasError('maxlength')">Last Name characters should be within 35</mat-error>
                <mat-error *ngIf="infoForm.controls.last_name.hasError('validation')">
                    {{infoForm.controls.last_name.errors.message}}
                </mat-error>
            </mat-form-field>
            <mat-form-field class="w-100 mt-1">
                <input type="email" matInput placeholder="Email" formControlName="email_id">
                <mat-error *ngIf="infoForm.controls.email_id.errors?.required">Email is required</mat-error>
                <mat-error *ngIf="infoForm.controls.email_id.hasError('invalidEmail')">Invalid email address</mat-error>
                <mat-error *ngIf="infoForm.controls.email_id.hasError('exist')">The email is already exists</mat-error>
                <mat-error *ngIf="infoForm.controls.email_id.hasError('validation')">
                    {{infoForm.controls.email_id.errors.message}}
                </mat-error>
            </mat-form-field>
            <mat-form-field class="w-100 mt-1">
                <input matInput placeholder="Company Name" formControlName="company">
            </mat-form-field>
            <mat-form-field class="w-100 mt-1">
                <input matInput placeholder="Phone Number" formControlName="phone_number"  
                    [value]="infoForm.get('phone_number').value | phone: 'US'">
                <mat-error *ngIf="infoForm.controls.phone_number.errors?.required">Phone Number is required</mat-error>
                <mat-error *ngIf="infoForm.controls.phone_number.hasError('exist')">The phone number already exists</mat-error>
                <mat-error *ngIf="infoForm.controls.phone_number.hasError('validation')">
                    {{infoForm.controls.phone_number.errors.message}}
                </mat-error>
            </mat-form-field>
            <div class="text-center mt-2">
                <mat-spinner-button [options] = "saveButtonOptions" mat-raised-button color="primary" >Save</mat-spinner-button>
            </div> 
        </form>
    </div>
    <div fxFlex="100" fxFlex.gt-sm="50" class="p-2" ngClass.sm="mt-2" ngClass.xs="mt-2">
        <h2 class="text-muted text-center">Password change</h2>
        <form [formGroup]="passwordForm" #resetPasswordChangeForm="ngForm" (ngSubmit)="onPasswordFormSubmit(resetPasswordChangeForm)">            
            <mat-form-field class="w-100 mt-2">
                <input matInput placeholder="Current Password" formControlName="currentPassword" type="password" required>
                <mat-error *ngIf="passwordForm.controls.currentPassword.errors?.required">Current Password is required</mat-error>
                <mat-error *ngIf="passwordForm.controls.currentPassword.hasError('minlength')">Current Password isn't long enough, minimum of 6 characters</mat-error>
                <mat-error *ngIf="passwordForm.controls.currentPassword.hasError('exist')">Current Password dosn't match</mat-error>
            </mat-form-field>
            <mat-form-field class="w-100 mt-1">
                <input matInput placeholder="New Password" formControlName="password" type="password">
                <mat-error *ngIf="passwordForm.controls.password.errors?.required">New Password is required</mat-error>
                <mat-error *ngIf="passwordForm.controls.password.hasError('minlength')">New Password isn't long enough, minimum of 6 characters</mat-error>
                <mat-error *ngIf="passwordForm.controls.password.hasError('validation')">
                    {{passwordForm.controls.password.errors.message}}
                </mat-error>
            </mat-form-field> 
            <mat-form-field class="w-100 mt-1">
              <input matInput placeholder="Confirm New Password" formControlName="confirmNewPassword" type="password">
              <mat-error *ngIf="passwordForm.controls.confirmNewPassword.errors?.required">Confirm New Password is required</mat-error>
              <mat-error *ngIf="passwordForm.controls.confirmNewPassword.hasError('mismatchedPasswords')">Passwords do not match</mat-error>
            </mat-form-field>
            <div class="text-center mt-2">
                <mat-spinner-button [options] = "changeButtonOptions" mat-raised-button color="primary" >Change</mat-spinner-button>
            </div>
        </form>
    </div>
</div> 
